// Autogenerated by build/webpack.config.js
// Do not change this file directly.

export const apiUrl = 'https://api-se.staging.ffdev.se/';
export const eidUrl = 'https://eid-se.backend-dev.ffdev.se';
export const frontUrl = 'https://frilansweb.flywheelstaging.com';
export const sentryDsn = 'https://ad415c4b0b8b41ecb3b7703bea0047a3@sentry.io/127654';
export const appUrl = 'account-web.staging.ffdev.se';
export const appEnv = 'staging';
export const version = 'undefined';



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/variables.js
 **/